import React,{useEffect,useState} from 'react'
import { images } from '../Example'
import { fetchBanner } from '../Firebase/Home-fb';

const Carousal = () => {

    const [current, setCurrent] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);
    const [banner,setBanner] = useState([]);
    let timeOut = null;

    useEffect(() => {

        const getBanner = async () => {
            const Bannerimg = await fetchBanner();
            setBanner(Bannerimg);
        }

        getBanner();

        timeOut =
            autoPlay &&
            setTimeout(() => {
                slideLeft();
            }, 4000);
    }
    ,[]);

    useEffect(()=>{},[banner]);

    const slideRight = () => {
        setCurrent(current === images.length - 1 ? 0 : current + 1);
    };

    const slideLeft = () => {
        setCurrent(current === 0 ? images.length - 1 : current - 1);
    };

  return (
    <div className="carousel_container">
        <div className="carousel" 
             onMouseEnter={() => { setAutoPlay(false); clearTimeout(timeOut); }}
             onMouseLeave={() => { setAutoPlay(true); }}>
             
            <div className="carousel_wrapper">
                {banner.map((image, index) => (
                    <div key={index}
                         className={index === current ? "carousel_card carousel_card-active" : "carousel_card"}>
                        <img className="card_image" src={image.banner_image} alt="" />
                    </div>
                ))}
                <div className="carousel_arrow_left" onClick={slideLeft}>&lsaquo;</div>
                <div className="carousel_arrow_right" onClick={slideRight}>&rsaquo;</div>
                <div className="carousel_pagination">
                    {banner.map((_, index) => (
                        <div key={index}
                             className={index === current ? "pagination_dot pagination_dot-active" : "pagination_dot"}
                             onClick={() => setCurrent(index)}></div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Carousal